import { Box, Button } from "@mui/material";
import { useLocale } from "../contexts/LocaleContext";

export default function LanguageSelector() {
  const { locale, switchLocale } = useLocale();

  return (
    <Box display="flex" alignItems="center" gap={0.5} sx={{ fontSize: 13 }}>
      <Button
        size="small"
        onClick={() => switchLocale("en")}
        sx={{
          minWidth: 0,
          px: 1,
          py: 0.25,
          color: locale === "en" ? "text.primary" : "text.secondary",
          fontWeight: locale === "en" ? 600 : 400,
          "&:hover": { color: "text.primary", bgcolor: "action.hover" },
        }}
      >
        EN
      </Button>
      <Box component="span" sx={{ color: "divider" }}>
        |
      </Box>
      <Button
        size="small"
        onClick={() => switchLocale("es")}
        sx={{
          minWidth: 0,
          px: 1,
          py: 0.25,
          color: locale === "es" ? "text.primary" : "text.secondary",
          fontWeight: locale === "es" ? 600 : 400,
          "&:hover": { color: "text.primary", bgcolor: "action.hover" },
        }}
      >
        ES
      </Button>
    </Box>
  );
}
